import React from "react";
import EntryOptions from "../../components/DataEntryOptions";

const DataEntryOptions = () => <EntryOptions />;

export default DataEntryOptions;
